import instance from "@/services/api";

export const serviceMastersAPI = {
  async getList() {
    return await instance().get('/handbook/service_masters/read/').then(res => res?.data)
  },
}

